import { render, staticRenderFns } from "./IntegrationsView.vue?vue&type=template&id=60b8b774"
import script from "./IntegrationsView.vue?vue&type=script&lang=js"
export * from "./IntegrationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports